import { triggerSimpleAjax } from "../../helpers/httpHelper";
import { OCR_INVOICE_API } from "../../helpers/constants/apiUrl";

export default function getOcrInvoice(req = "", isList = false) {
    return new Promise((res, rej) => {
        if (!req && req !== 0) {
            return res(isList ? { results: [] } : {});
        }

        let url;
        if (isList) {
            if (typeof req === "string" && (req.startsWith("?") || req.includes("workflow_object="))) {
                url = `${OCR_INVOICE_API}${req.startsWith("?") ? req : `?${req}`}`;
            } else {
                url = `${OCR_INVOICE_API}?no-pagination&workflow_object=${encodeURIComponent(req)}`;
            }
        } else {
            url = `${OCR_INVOICE_API}${encodeURIComponent(req)}/`;
        }

        try {
            triggerSimpleAjax(
                url,
                "GET",
                {},
                (response) => {
                    res(response);
                },
                (error) => {
                    rej(error);
                }
            );
        } catch (err) {
            rej(err);
        }
    });
}
